import React, { useState } from 'react';

import { useLots } from '../api/getLots';
import { RolesView } from './RolesView';
import { SelectLotModal } from './SelectLotModal';
import { SetupOverlay } from './SetupOverlay';

export const RolesOverlay = ({ resource, id, procurementName, onClose }) => {
  const [lotId, setLotId] = useState(null);
  const [isPickerOpen, setIsPickerOpen] = useState(true);
  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);

  const { data: lots, refetch, isFetchedAfterMount } = useLots(resource, id);
  const lot = lots.find(({ lot_id }) => lot_id === lotId);

  const picker = (
    <SelectLotModal
      lots={lots}
      isLoaded={isFetchedAfterMount}
      open={isPickerOpen}
      handleClose={() => (lot ? setIsPickerOpen(false) : onClose())}
      onSelect={(selectedLot) => {
        setLotId(selectedLot.lot_id);
        setIsPickerOpen(false);
      }}
    />
  );

  if (!lot) return picker;

  return (
    <SetupOverlay
      procurementName={procurementName}
      crumbs={[{ label: 'Roles', onClick: () => setIsPickerOpen(true) }, { label: lot.name }]}
      isModalOpen={isPickerOpen || isRoleModalOpen}
      onClose={onClose}
    >
      <RolesView
        key={lot.lot_id}
        resource={resource}
        id={id}
        lot={lot}
        onChanged={refetch}
        onModalChange={setIsRoleModalOpen}
      />
      {picker}
    </SetupOverlay>
  );
};
